/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Time_Hoursago1Inputs */

const he_time_hoursago1 = /** @type {(inputs: Time_Hoursago1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`לפני ${i?.count}h`)
};

const en_time_hoursago1 = /** @type {(inputs: Time_Hoursago1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}h ago`)
};

/**
* | output |
* | --- |
* | "{count}h ago" |
*
* @param {Time_Hoursago1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const time_hoursago1 = /** @type {((inputs: Time_Hoursago1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Hoursago1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_time_hoursago1(inputs)
	return en_time_hoursago1(inputs)
});
export { time_hoursago1 as "time_hoursAgo" }